<template>
    <navBar title="Ares - Agents" :home="true" type="agents"/>
</template>
  
<script>
    import navBar from '@/components/ui/navbars/navbar.vue';
  
    export default {
        components: {
            navBar,
        },
    }
</script>  